var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldgrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48391 0C8.64652 0 8.80913 0.0353496 8.9576 0.102514L15.6139 2.92694C16.3916 3.2557 16.9713 4.02278 16.9678 4.94894C16.9501 8.45562 15.5079 14.8716 9.41714 17.7879C8.8268 18.0707 8.14102 18.0707 7.55068 17.7879C1.45995 14.8716 0.0176909 8.45562 1.60787e-05 4.94894C-0.00351888 4.02278 0.576214 3.2557 1.3539 2.92694L8.01376 0.102514C8.1587 0.0353496 8.3213 0 8.48391 0ZM8.48391 2.36135V15.727C13.3622 13.3621 14.6736 8.13393 14.7054 4.99843L8.48391 2.36135Z",
    fill: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldgrey);
export default __webpack_public_path__ + "static/media/shield grey.37bda6ff2e4ba3195808bce99d98f8f6.svg";
export { ForwardRef as ReactComponent };